export const formSettings = {
    form: 'client-onboarding-wizard',
    destroyOnUnmount: false,
    keepDirtyOnReinitialize: true,
    enableReinitialize: true,
    forceUnregisterOnUnmount: false
};



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/client/steps/settings.jsx